import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Env } from '@contexts/AppContext';

import CancelForm from './CancelForm';

interface CancelFeedbackProps {
  env: Env;
}

const CancelFeedback = ({ env }: CancelFeedbackProps) => {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <div className="mx-auto px-16">
        <h1 className="m-0 mx-auto max-w-[740px] text-center font-suisse-neue text-headline-sm font-normal xs:text-headline-lg xs:font-normal">
          Please choose the main reason you’re cancelling your subscription.
        </h1>
        <div className="mx-auto mt-32 max-w-[600px]">
          <CancelForm env={env} />
        </div>
      </div>
    </QueryClientProvider>
  );
};

export default CancelFeedback;
